import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=f663b582&"
import script from "./frame.vue?vue&type=script&lang=js&"
export * from "./frame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f663b582')) {
      api.createRecord('f663b582', component.options)
    } else {
      api.reload('f663b582', component.options)
    }
    module.hot.accept("./frame.vue?vue&type=template&id=f663b582&", function () {
      api.rerender('f663b582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_admin/frame.vue"
export default component.exports